// extracted by mini-css-extract-plugin
module.exports = {"formCard":"FormCard_formCard_2De6-","strong":"FormCard_strong_1soJs","mobileFormCard":"FormCard_mobileFormCard_2erG5"};